import { FC, useEffect } from 'react';
import PoHistory from 'src/components/PoHistory';
import useAutoFocus from 'src/hooks/useAutoFocus';
import useGuideMe from 'src/hooks/useGuideMe';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import useWindowSize from 'src/hooks/useWindowSize';
import Button from '../../components/design-system/Button';
import CancelPo from './CancelPo';
import CancelReceipt from './CancelReceipt';
import ChangePoAssignment from './ChangePoAssignment';
import CompleteReceipt from './CompleteReceipt';
import CreateLinkedInvoice from './CreateLinkedInvoice';
import DeleteReceipt from './DeleteReceipt';
import useGuideMeSteps from './GuideMeSteps';
import PrintWizard from './PrintWizard';
import ReopenReceipt from './ReopenReceipt';
import SaveReceipt from './SaveReceipt';
import UnDeleteReceipt from './UnDeleteReceipt';

export interface ReceiptDetailsActionsProps {
  receiptId: string;
  showScans: boolean;
  isCurrentDocLinked: boolean;
  TogglePreview: () => void;
  poId: number;
}

const ReceiptDetailsActions: FC<ReceiptDetailsActionsProps> = ({
  receiptId,
  showScans,
  TogglePreview,
  poId,
  isCurrentDocLinked,
}) => {
  const { receiptData } = useReceiptDetails();
  const guideMeSteps = useGuideMeSteps(isCurrentDocLinked);
  const { width } = useWindowSize();

  const buttonRef = useAutoFocus(true, []);
  const { guideMe, openGuideMe } = useGuideMe({
    steps: guideMeSteps,
    guideId: 'receipt-details-guide',
    focusRef: buttonRef,
  });

  useEffect(() => {
    openGuideMe();
  }, [openGuideMe]);

  const isLoaded = !!receiptData && !!Object.keys(receiptData)?.length;

  return width < 1300 ? (
    <div className="flex flex-wrap">
      {isLoaded && <SaveReceipt />}
      <div className="flex-grow" />
      {isLoaded && (
        <>
          <CreateLinkedInvoice receiptId={receiptId} isCurrentDocLinked={isCurrentDocLinked} />
          <CompleteReceipt />
          <ChangePoAssignment />
          <CancelPo poId={poId} />
          <CancelReceipt />
          <ReopenReceipt />
          <DeleteReceipt />
          <UnDeleteReceipt />
        </>
      )}
      <div className="flex-grow" />
      <div className={`flex flex-wrap`}>
        <PoHistory title={'Receipt'} />
        <PrintWizard />
        {guideMe}
        <Button
          color="light"
          onClick={TogglePreview}
          endIcon={
            <div className="bg-dark rounded-full h-5 w-5 flex items-center justify-center text-[0.6rem] text-white">
              {receiptData?.attachments?.length || 0}
            </div>
          }
        >
          {showScans ? 'Hide Scans' : 'Show Scans'}
        </Button>
      </div>
    </div>
  ) : (
    <nav className="flex justify-between flex-wrap">
      {isLoaded && (
        <div className="flex">
          <SaveReceipt />
          <div style={{ width: width >= 1300 ? '150px' : '5%' }} />
        </div>
      )}
      {isLoaded && (
        <div className="flex flex-wrap">
          <CreateLinkedInvoice receiptId={receiptId} isCurrentDocLinked={isCurrentDocLinked} />
          <CompleteReceipt />
          <ChangePoAssignment />
          <CancelPo poId={poId} />
          <CancelReceipt />
          <ReopenReceipt />
          <DeleteReceipt />
          <UnDeleteReceipt />
        </div>
      )}
      <div className={`flex flex-wrap`}>
        <PoHistory title={'Receipt'} />
        <PrintWizard />
        {guideMe}
        <Button
          color="light"
          onClick={TogglePreview}
          endIcon={
            <div className="bg-dark rounded-full h-5 w-5 flex items-center justify-center text-[0.6rem] text-white">
              {receiptData?.attachments?.length || 0}
            </div>
          }
        >
          {showScans ? 'Hide Scans' : 'Show Scans'}
        </Button>
      </div>
    </nav>
  );
};

export default ReceiptDetailsActions;
